import { render, staticRenderFns } from "./canal.vue?vue&type=template&id=351d613c&scoped=true&"
import script from "./canal.vue?vue&type=script&lang=js&"
export * from "./canal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d613c",
  null
  
)

export default component.exports